import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';
import { Utils } from '../../providers/utils';

@Component({
  selector: 'page-news-details',
  templateUrl: 'news-details.html',
})

export class NewsDetailsPage {

  public newsItem: any;

  constructor(
    private nav: NavController,
    private params: NavParams
  ) {
  }

  ionViewDidEnter() {
    this.newsItem = this.params.get("item");
  }

  public formatNum(num){
    if(!num){return "";}
    return Utils.formatNumberToString(num);
  }
}


// WEBPACK FOOTER //
// ./src/pages/news/news-details.ts